import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './IconButton.css';

export interface IconButtonProps
  extends Omit<
    ButtonHTMLAttributes<HTMLButtonElement>,
    'type' | 'onClick' | 'aria-label' | 'className' | 'children'
  > {
  /** Accessible name — required, the icon alone says nothing to a reader. */
  label: string;
  onPress: () => void;
  /** The icon (typically an <Icon> wrapping a glyph). */
  children: ReactNode;
  className?: string;
}

/**
 * IconButton — 44px round borderless icon affordance. Plain chrome, not a
 * 3D Button: transparent at rest, 8% text wash while pressed, focus ring.
 * For icon-only actions that would read too loud as a full Button (e.g.
 * the pencil edit control in the profile hero).
 */
export function IconButton({ label, onPress, children, className, ...rest }: IconButtonProps) {
  return (
    <button
      type="button"
      className={clsx('fluent-icon-button', className)}
      aria-label={label}
      onClick={onPress}
      {...rest}
    >
      {children}
    </button>
  );
}
